import Marquee from "react-fast-marquee";

export default function DiagonalMarquee() {
  return (
    <section className="relative overflow-hidden bg-white py-14 lg:py-20" data-testid="diagonal-marquee">
      <div className="relative left-1/2 w-[130%] -translate-x-1/2 -rotate-3 bg-brand-blue py-4 shadow-[0_10px_30px_-10px_rgba(0,35,102,0.4)]">
        <Marquee speed={45} gradient={false} autoFill>
          {[...Array(6)].map((_, i) => (
            <span key={i} className="px-6 font-display text-2xl font-black uppercase tracking-tight text-white sm:text-3xl">
              EDUCASER GROUP <span className="text-brand-red-light">•</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
